export default "__VITE_ASSET__oz5dE2nU__"